import api from '@/services/api'

export default {
  state: {
    isLoggedInEthosReports: !!localStorage.getItem('tokenEthosReports'),
    userEthosReports: {
      id: 0,
      empresaId: 0,
      nome: '',
      tipo: '',
      profiles: [],
    },
  },

  mutations: {
    AUTH(state, user) {
      state.isLoggedInEthosReports = true
      state.userEthosReports = {
        id: user.id,
        empresaId: user.empresaId,
        nome: user.nome,
        tipo: user.tipo,
        profiles: user.profiles,
      }
    },

    LOGOUT(state) {
      state.isLoggedInEthosReports = false
      state.userEthosReports = {
        id: 0,
        empresaId: 0,
        nome: '',
        tipo: '',
        profiles: [],
      }
    },
  },

  actions: {
    async signInBasic({ commit }, credentials) {
      try {
        const response = await api.post('/auth/sign-in-basic', {
          email: credentials.email,
          senha: credentials.senha,
        })

        const data = response && response.data ? response.data : null
        const token = data && data.token ? data.token : ''

        const user = {
          id: data && data.user ? data.user.id : 0,
          empresaId: data && data.user ? data.user.empresaId : 0,
          nome: data && data.user ? data.user.nome : '',
          tipo: data && data.user ? data.user.tipo : '',
          profiles: data && data.user ? data.user.profiles : [],
        }

        localStorage.setItem('tokenEthosReports', token)
        commit('AUTH', user)
      } catch (error) {
        commit('LOGOUT')
        throw error
      }
    },

    async passwordRecovery({ commit }, email) {
      try {
        const response = await api.post('/auth/password-recovery', {
          email,
        })

        return response || null
      } catch (error) {
        throw error
      }
    },

    async newPassword({ commit }, data) {
      try {
        const response = await api.post('/auth/new-password', data)

        return response || null
      } catch (error) {
        throw error
      }
    },

    async getMicrosoftLink({ commit }) {
      try {
        const response = await api.get('/auth/sign-in-microsoft/link')
        return response && response.data ? response.data : null
      } catch (error) {
        commit('LOGOUT')
        throw error
      }
    },

    async signInMicrosoft({ commit }, code) {
      try {
        const response = await api.post('/auth/sign-in-microsoft/code', code)

        const data = response && response.data ? response.data : null
        const token = data && data.token ? data.token : ''

        const user = {
          id: data && data.user ? data.user.id : 0,
          empresaId: data && data.user ? data.user.empresaId : 0,
          nome: data && data.user ? data.user.nome : '',
          tipo: data && data.user ? data.user.tipo : '',
          profiles: data && data.user ? data.user.profiles : [],
        }

        localStorage.setItem('tokenEthosReports', token)
        commit('AUTH', user)
      } catch (error) {
        commit('LOGOUT')
        throw error
      }
    },

    logout: ({ commit }) => {
      commit('LOGOUT')
    },
  },

  getters: {
    isLoggedInEthosReports: (state) => state.isLoggedInEthosReports,
    user: (state) => state.userEthosReports,
  },
}
